<template>
  <section class="iv-public-sentiment-todo iv-main-width">
    <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line iv-m-t-40 iv-m-b-16">处理人待办处理舆情</h1>
    <article class="iv-public-sentiment-todo-content">
      <!-- 基础信息 -->
      <FormLayout
        ref="baseConfig" 
        :readOnly="true"
        :model="publicInfo"
        :list="baseConfig">
      </FormLayout>
      <LayoutTitle class="iv-m-b-36" title="处理信息">
        <FormLayout
          ref="attachmentInfo" 
          :readOnly="isView"
          :model="attachmentInfo"
          :list="handleConfig">
        </FormLayout>
        <DragTable
          noSearch
          ref="DragTable"
          class="iv-m-t-12"
          :showEdit="false"
          :showDelete="false"
          :showSelect="false"
          :showPage="false"
          :columns="resultTableConfig" 
          :tableData="publicInfo.approveLogs">
        </DragTable>
      </LayoutTitle>
    </article>
    <FooterOperator>
      <Button v-if="!isView" class="iv-m-r-8" type="save" @click="saveInfo">保存</Button>
      <Button v-if="!isView" class="iv-m-r-8" type="save" :disabled="disabled" @click="submitHandledResult">提交处理结果</Button>
      <Button type="close" @click="back">关闭</Button>
    </FooterOperator>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </section>
</template>

<script>
import { timeFormat } from '@/utils'
import FormLayout from '@/components/layout/form'
import DragTable from '@/components/drag-table-inline'
import FooterOperator from '@/components/footer-operator'
import LayoutTitle from '@/components/layout/layout-title'
import { baseConfig, handleConfig, resultTableConfig } from './form-config.js'

export default {
  data () {
    return {
      publicInfo: {},
      attachmentInfo: {},
      dictMap: {},
      spinShow: false,
      baseConfig: [],
      handleConfig: [],
      resultTableConfig: [],
      disabled: false
    }
  },
  async created () {
    this.isView = this.$route.query.view == 'see'
    this.processId = this.$route.query.processId
    this.publicOpinionId = this.$route.query.publicOpinionId
    this.spinShow = true
    this.getCodeTable('BOE62')
    this.getPostBarConfig()
    await this.getCodeTable('BOE82')
    await this.getCodeTable('BOE48')
    await this.getPublicSentimentDetail()
    this.baseConfig = baseConfig.call(this)
    this.handleConfig = handleConfig.call(this)
    this.resultTableConfig = resultTableConfig.call(this)
    this.spinShow = false
  },
  mounted () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.$set(this.attachmentInfo, 'userName', sessionStorage.getItem('userName'))
      this.$set(this.attachmentInfo, 'userId', sessionStorage.getItem('userId'))
      this.$set(this.attachmentInfo, 'orgName', sessionStorage.getItem('cultureName')) //用户的行政机构名称
      this.$set(this.attachmentInfo, 'orgId', sessionStorage.getItem('cultureId'))
      this.$set(this.attachmentInfo, 'createDate', new Date())
    },
    //获取详情
    getPublicSentimentDetail () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/module/publicOpinionProcess/get',
          method: 'get',
          data: {
            processId: this.processId
          }
        }).then(({data}) => {
          this.publicInfo = data.data || {}
          this.publicInfo.postDate = new Date(this.publicInfo.postDate)
          this.publicInfo.createDate = new Date(this.publicInfo.createDate)
          this.publicInfo.discoverTime = new Date(this.publicInfo.discoverTime)
          this.publicInfo.publicOpinionOrgIds = this.publicInfo.publicOpinionOrg
          this.publicInfo.opinionLevels = this.publicInfo.opinionLevels[0] || ''
          this.publicInfo.publicOpinionType = this.publicInfo.publicOpinionType ? this.publicInfo.publicOpinionType.split(',') : []
          if (this.publicInfo.publicOpinionFileId) {
            this.getActivityFiles(this.publicInfo.publicOpinionFileId, 'uploadFile', 'publicInfo')
          }
          this.attachmentInfo = Object.assign({}, this.attachmentInfo, data.data.publicOpinionProcess || {})
          if(this.attachmentInfo.createDate) {
            this.attachmentInfo.createDate = new Date(this.attachmentInfo.createDate)
          } else {
            this.attachmentInfo.createDate = new Date()
          }
          if (this.attachmentInfo.processFileId) {
            this.groupId = this.attachmentInfo.processFileId
            this.getActivityFiles(this.attachmentInfo.processFileId, 'handleUploadFile', 'attachmentInfo')
          } else {
            this.groupId = this.getUuid()
          }
          resolve()
        })
      })
    },
    //保存
    saveInfo () {
      this.$refs.attachmentInfo.validate((valid) => {
        if (!valid) {
          return this.$Message.error('校验未通过')
        }
        this.$ajax({
          url: '/api-uum/module/publicOpinionProcess/update',
          method: 'PUT',
          data: {
            orgId: this.attachmentInfo.orgId,
            orgName: this.attachmentInfo.orgName,
            processContent: this.attachmentInfo.processContent,
            processFileId: this.groupId,
            processId: this.processId,
            publicOpinionId: this.publicOpinionId,
            userName: this.attachmentInfo.userName,
            userId: this.attachmentInfo.userId,
            createDate: timeFormat(this.attachmentInfo.createDate)
          }
        }).then(({data}) => {
          this.$Message.success('保存成功')
        })
      })
    },
    //提交
    submitHandledResult () {
      this.$refs.attachmentInfo.validate((valid) => {
        if (!valid) {
          return this.$Message.error('校验未通过')
        }
        this.$ajax({
          url: '/api-uum/module/publicOpinionProcess/submitProcess',
          method: 'PUT',
          data: {
            orgId: this.attachmentInfo.orgId,
            orgName: this.attachmentInfo.orgName,
            processContent: this.attachmentInfo.processContent,
            processFileId: this.groupId,
            processId: this.processId,
            publicOpinionId: this.publicOpinionId,
            userName: this.attachmentInfo.userName,
            userId: this.attachmentInfo.userId,
            createDate: timeFormat(this.attachmentInfo.createDate),
            processState: this.attachmentInfo.processState
          }
        }).then(({data}) => {
          this.$Message.success('提交成功')
          this.disabled = true
          this.back()
        })
      })
    },
    //返回
    back () {
      window.close()
    },
    //获取附件id 第一次上传附件 本地生产uuid
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    //获取文件信息
    getActivityFiles (groupId, key, formKey) {
      this.$ajax({
        url: 'api-uum/file/listFilesByGroupId',
        method: 'GET',
        data: {
          isPage: false,
          groupId: groupId
        }
      }).then(({data}) => {
        this.$set(this[formKey], key, data.data || [])
      })
    },
    //获取现地贴吧配置
    getPostBarConfig () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/module/postBarMapping/listAvailablePostBar',
          method: 'get',
          data: {
            orgId: ''
          }
        }).then(({data}) => {
          this.dictMap['postBar'] = data.data.map(item => ({
            label: item.postBarName,
            value: item.postBarId,
            ...item
          }))
          resolve()
        })
      })
    },
    //获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, [])
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: 'YWX05'
          }
        }).then(({data}) => {
          this.dictMap[code] = data.data.map(item => ({
            label: item.title,
            value: item.value
          }))
          resolve()
        })
      })
    }
  },
  components: {
    DragTable,
    FormLayout,
    LayoutTitle,
    FooterOperator
  }
}
</script>

<style scoped lang="scss">
.iv-public-sentiment-todo {
  background: #fff;
  padding: 16px;
}
</style>